// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14pR_","col":"styles_col__3KHrs"};